import { SITE } from './site';

export const faqGroups = [
  {
    heading: 'Getting started',
    items: [
      {
        q: 'Is DashLink Gaming free?',
        a: 'Yes. Creating an account and using every feature — games, chat, leaderboards, squads and watch parties — is free. The site may show ads to cover running costs.',
      },
      {
        q: 'Which games can I actually play on DashLink?',
        a: 'Tic-Tac-Toe and Checkers are fully playable in your browser against other people in real time. Other titles in the games list (imported from RAWG.io and FreeToGame) have chat rooms and squad matching so you can meet teammates, but the games themselves are played on their own platforms.',
      },
      {
        q: 'Why do I need to verify my email?',
        a: 'Verification keeps bots and throwaway accounts out of multiplayer rooms. Until you verify, you can browse and chat, but creating or joining rooms is locked. Check your inbox (and spam folder) for the link, or resend it from the banner in the app.',
      },
      {
        q: 'I forgot my password. What do I do?',
        a: 'Click “Forgot password?” on the sign-in page and enter your email. You will receive a reset link that works for one hour. For security, you can request at most three emails every 15 minutes.',
      },
    ],
  },
  {
    heading: 'Playing and competing',
    items: [
      {
        q: 'How do I play with a friend?',
        a: 'Open Tic-Tac-Toe or Checkers, create a room and share the room code. Your friend enters the code and presses “Join Room”. Every move is checked by our server, so nobody can cheat by editing the page.',
      },
      {
        q: 'How does the leaderboard work?',
        a: 'Wins in built-in games add points to your score. The global leaderboard ranks all players by score, and each game also has its own leaderboard.',
      },
      {
        q: 'What is “Looking for Squad”?',
        a: 'Press “Find Players” in any game to appear on that game’s Looking for Squad list for about 30 minutes and see who else is searching. Send an invite; if they accept, you both land in the same room.',
      },
      {
        q: 'How do Favourites work?',
        a: 'Tap the heart next to a player to save them. Players are also saved automatically when you accept each other’s squad invite. Favourites appear above the squad list so you can re-invite them with one tap.',
      },
    ],
  },
  {
    heading: 'Chat, voice and watch parties',
    items: [
      {
        q: 'How do voice notes work?',
        a: 'The microphone button uses your browser’s speech recognition to turn what you say into text in the message box. Review it, edit if needed, then send. We never record or store audio. It works best in Chrome and Edge; some browsers (such as Firefox) do not support it yet.',
      },
      {
        q: 'Can I watch streams with my squad?',
        a: 'Yes. In any room, paste a Twitch or YouTube link into the Watch Party box and the stream appears for everyone in the room, right above the chat.',
      },
      {
        q: 'How do I report someone?',
        a: `Email ${SITE.email} with their username, where it happened and a screenshot if possible. See the Community Guidelines for what is and isn’t allowed.`,
      },
    ],
  },
  {
    heading: 'Privacy and account',
    items: [
      {
        q: 'What data do you collect?',
        a: 'Your account details, profile, game stats, chat messages and social activity such as friends and invites. Passwords are hashed and never visible to us. The Privacy Policy explains everything in detail.',
      },
      {
        q: 'Can I hide my profile?',
        a: 'Yes. In your profile, set Profile Visibility to Private. Only you and players you have saved as friends can then see your profile and stats, and you appear as “Private player” on leaderboards.',
      },
      {
        q: 'How do I change my cookie choices?',
        a: 'Click “Cookie settings” in the site footer at any time to accept or decline analytics and advertising cookies.',
      },
      {
        q: 'How do I delete my account?',
        a: 'Open your profile, scroll to “Your Data” and click “Delete My Account”. After you confirm your password, your profile, stats, chat messages, friends and invites are deleted immediately. You can also download everything first with “Export My Data”.',
      },
    ],
  },
];
